// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1H2np","bigColWidth":"Table_bigColWidth__1BGNm","biggerColWidth":"Table_biggerColWidth__2EEW6","row":"Table_row__3Dlm3","col":"Table_col__7rv0j"};